<template>
	<div class="modal fade" id="reportingModal" role="dialog" aria-labelledby="reportingModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="reportingModalLabel">{{ $t("report.title") }}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="loader" v-show="loading"></div>
					<div v-if="!loading && docInfo">
						<h5 class="w-100 mb-3">{{ $t("report.template") }}</h5>
						<div class="row">
							<div class="mb-3 col-md-6">
								<span class>
									<strong>{{ $t("report.category") }}</strong>
								</span>
								<div>{{docInfo.categoryName}}</div>
							</div>
							<div class="mb-3 col-md-6">
								<span class>
									<strong>{{ $t("report.template") }}</strong>
								</span>
								<div>{{docInfo.reportName}}</div>
							</div>
						</div>
						<hr />
						<div>
							<div class="row">
								<h5 class="mb-3 col-md-12">{{ $t("report.params") }}</h5>
								<div v-for="item in docInfo.params" :key="item.ide" class="col-md-6 mb-3">
									<parameter :item="item" :readonly="true"></parameter>
								</div>
								<hr />
							</div>
							<div class="row">
								<h5 class="mb-3 col-md-12">{{ $t("report.format") }}</h5>
								<div class="mb-3 col-md-6">
									<span class>
										<strong>{{ $t("report.chooseFormat") }}</strong>
									</span>
									<div>{{docInfo.format}}</div>
								</div>
								<div class="mb-3 col-md-6">
									<span class>
										<strong>{{ $t("report.docTitle") }}</strong>
									</span>
									<div>{{docInfo.title}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" @click="hide">{{$t("buttons.close")}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import parameter from '../reports/parameter';

export default {
	components: {
		parameter
	},
	props: {
		value: {},
		show: {
			type: Boolean,
			required: false
		}
	},
	data() {
		return {
			docInfo: null,
			loading: true
		};
	},
	methods: {
		getInfo() {
			this.$http
				.get(`/api/reporting/docs/${this.value}/info`)
				.then(result => {
					result.data.params = JSON.parse(result.data.params);
					this.docInfo = result.data;
				})
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$t('notifications.serverError')
					})
				)
				.then(() => (this.loading = false));
		},
		hide() {
			$(this.$el).modal('hide');
		},
		onClose() {
			this.docInfo = null;
			this.$emit('onClose');
			this.$emit('update:show', false);
		}
	},
	mounted() {
		// add modal close listener
		$(this.$el).on('hidden.bs.modal', this.onClose);
		// add modal open listener
		$(this.$el).on('show.bs.modal', this.getInfo);
	},
	beforeDestroy() {
		// remove listeners
		$(this.$el).off('hidden.bs.modal');
		$(this.$el).off('show.bs.modal');
	},
	watch: {
		show: function(val) {
			$(this.$el).modal(val ? 'show' : 'hide');
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
